export default {
  remote: 'simplify_hub_security_metrics_mfe',
  name: 'security-metrics',
  source: 'https://github.com/telus/simplify-mfe-components',
  urlMapping: {
    localhost: 'http://localhost:4399/mf-manifest.json',
    'simplify.developers.telus.digital': 'https://assets.wcpreview.telus.com/1100769639/simplify-security-metrics/v1/mf2/mf-manifest.json',
    'simplify.staging.developers.telus.digital': 'https://assets.wcstage.telus.com/1100769639/simplify-security-metrics/v1/mf2/mf-manifest.json',
    'simplify.telus.com': 'https://assets.telus.com/1100769639/simplify-security-metrics/v1/mf2/mf-manifest.json',
  },
};
